<script>
import { mapActions, mapGetters } from 'vuex';
import {InMemoryProvider, ODataProvider} from "pbas-vue-components";
import OptOutReimbursementHeaders from "../headers/OptOutReimbursementHeaders";
import { planSetter } from "../mixins/planSetter";

export default {
  name: "Reimbursements",
  mixins: [planSetter],
  props: {
    planId: String,
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["reimbursements"]),
  },
  data() {
    return {
      loading: false,
      provider: undefined,
      headers: OptOutReimbursementHeaders,
    };
  },
  methods: {
    ...mapActions("optouts", ["loadReimbursements"]),
    async load() {
        if (!this.selectedPlan?.Id) return;
        this.loading = true;
        if (this.selectedPlan?.Id) {
          const url =  `optouts/odata/Reimbursements/ByPlan(plan=${this.selectedPlan.Id})`
          this.provider = new ODataProvider(this.$axiosHttp, url, this.headers);
        }
    },
  },
  watch: {
    selectedPlan: {
      deep: true,
      immediate: true,
      handler(newPlan) {
        if (newPlan?.Id) {
          this.$nextTick(() => this.load())
        }
      }
    }
  },
  async mounted() {
    if(this.selectedPlan?.Id) {
      await this.load();
    }
  }
};
</script>
<style>
.centered-div {
  margin-left: auto;
  margin-right: auto;
}
</style>

<template>
  <div style="padding: 20px">
    <material-card
      icon="mdi-cash-refund"
      title="Reimbursements"
      :color="$vuetify.theme.themes.light.primary"
    >
      <pbas-data-table
        :exporters="$exporters"
        ref="reimbursementsTable"
        :dataProvider="provider"
        :loading="loading"
        fileNamePrefix="reimbursements"
        identifier="reimbursementsTable"
      />
      
    </material-card>
  </div>
</template>